import { StateSchema } from 'app/config/storeConfig/types';
import { WarehouseForBooking } from 'entities/Warehouse';

export const getWarehouseInfo = (state: StateSchema): Nullable<WarehouseForBooking> => state.bookingPage.warehouseInfo;
